import { defineMessages } from 'react-intl';
import styled from 'styled-components';

import { ScarcityIcon } from '@sorare/core/src/atoms/icons/ScarcityIcon';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelS } from '@sorare/core/src/atoms/typography';
import type { PrintablePlayerSortName } from '@sorare/core/src/contexts/config';
import { formatScarcity } from '@sorare/core/src/lib/cards';
import type { StatsRarity } from '@sorare/core/src/lib/playerSearchView';
import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';
import { marketValueSorts } from '@sorare/core/src/lib/scouting-center';

import { SortTable } from '#src/components/searchPlayerTable/SortTable/index.tsx';
import { useManagePlayerSearchView } from '#src/searchCommonPlayer/StatsManager/useManagePlayerSearchView.ts';

const StyledLabelS = styled(LabelS)`
  vertical-align: middle;
`;

export const messages = defineMessages({
  inSeasonTooltip: {
    defaultMessage:
      'In season: limited and rare show an average of the last 3 primary market sales. Super rare and unique show the last recorded price.',
  },
  classicTooltip: {
    defaultMessage:
      'Classic: limited and rare show an average of the last 3 public sales. Super rare and unique show the last recorded price.',
  },
});

type Props = {
  rarity: StatsRarity;
  sorts: PrintablePlayerSortName[];
  refine: (_sorts: PrintablePlayerSortName[]) => void;
};

export const SortByMarketValue = ({ rarity, sorts, refine }: Props) => {
  const { statsManager } = useManagePlayerSearchView();

  const indexes = marketValueSorts(
    rarity,
    statsManager[PlayerSearchViewAttributes.SEASONALITY]
  );

  const label = (
    <Horizontal gap={0.5}>
      <ScarcityIcon rarity={rarity} />
      <StyledLabelS className="uppercase">
        {formatScarcity(rarity)}
      </StyledLabelS>
    </Horizontal>
  );

  return (
    <SortTable ascFirst indexes={indexes} sorts={sorts} refine={refine}>
      {label}
    </SortTable>
  );
};
